import { NotificationSeverity } from '@/components/notifications/Notification';
import { FinalizeService, ServeCustomer } from '../../models';
import { useDispatch } from 'react-redux';
import { useNotification } from '@/hooks';
import inboxService, {
  useFinalizeServiceMutation,
  useMarkAsPendingMutation,
  useServeCustomerMutation,
  useToggleInboxIsTakenMutation,
} from '../../services/inbox.service';

export const useInboxActions = () => {
  const { showNotification } = useNotification();
  const dispatch = useDispatch();

  const handleConflictError = (error: any, defaultMsg: string) => {
    if (error?.status === 409) {
      showNotification(
        error?.data?.message ||
          'El ticket ya está siendo atendido por otro agente',
        NotificationSeverity.error,
        4000
      );
      dispatch(inboxService.util.invalidateTags(['Inboxes']));
    } else {
      console.error(`${defaultMsg}: `, error);
      showNotification(defaultMsg, NotificationSeverity.error, 2000);
    }
  };

  const [serveCustomer, { isLoading: isServeCustomerLoading }] =
    useServeCustomerMutation();

  const onServeCustomer = async ({ inboxId, attentionUser }: ServeCustomer) => {
    try {
      await serveCustomer({ inboxId, attentionUser }).unwrap();
      return true;
    } catch (error) {
      handleConflictError(
        error,
        'Error al cambiar el estado a atendiendo en bandeja de entrada'
      );
      return false;
    }
  };

  const [finalizeService, { isLoading: isFinalizeServiceLoading }] =
    useFinalizeServiceMutation();

  const onFinalizeService = async ({
    inboxId,
    documentNumber,
    success,
  }: FinalizeService) => {
    try {
      await finalizeService({ inboxId, documentNumber, success }).unwrap();
      showNotification(
        'Finalizado con éxito',
        NotificationSeverity.success,
        2000
      );
      return true;
    } catch (error) {
      handleConflictError(
        error,
        'Error al finalizar el servicio en bandeja de entrada'
      );
      return false;
    }
  };

  const [markAsPending, { isLoading: isMarkAsPendingLoading }] =
    useMarkAsPendingMutation();

  const onMarkAsPending = async (inboxId: string) => {
    try {
      await markAsPending(inboxId).unwrap();
      return true;
    } catch (error) {
      console.error(
        'Error al cambiar el estado de bandeja de entrada a PENDING: ',
        error
      );
      showNotification(
        'Error al intentar marcar el pedido como PENDIENTE',
        NotificationSeverity.error,
        2000
      );
      return false;
    }
  };

  const [toggleInboxIsTaken, { isLoading: isToggleInboxIsTakenLoading }] =
    useToggleInboxIsTakenMutation();

  const onToggleInboxIsTaken = async (args: {
    inboxId: string;
    takenById: string;
    takenByName: string;
  }) => {
    try {
      await toggleInboxIsTaken(args).unwrap();
      return true;
    } catch (error) {
      handleConflictError(error, 'Error al tomar el ticket');
      return false;
    }
  };

  return {
    onServeCustomer,
    isServeCustomerLoading,
    onFinalizeService,
    isFinalizeServiceLoading,
    onMarkAsPending,
    isMarkAsPendingLoading,
    onToggleInboxIsTaken,
    isToggleInboxIsTakenLoading,
  };
};
